module.exports = __webpack_public_path__ + "img/orange.ca8b0614.svg";